import Vue from 'vue'
import {
  Button,
  Message,
  Pagination,
  Input,
  MessageBox,
  Table,
  TableColumn,
  Container,
  Aside,
  Menu,
  Submenu,
  MenuItem,
  Main,
  Breadcrumb,BreadcrumbItem,
  Form,FormItem,Card,Dialog
} from 'element-ui'

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.use(Button)
Vue.use(Pagination)
Vue.use(Input)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Container)
Vue.use(Aside)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Main)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Card)
Vue.use(Dialog)
